import React from 'react'
import { Grid as BaseGrid, styled, Hidden as BaseHidden } from '@mui/material'
import { Button } from '@chilecompra/react-kit'

export const DesktopNavigation = styled('div')`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const Hidden = styled(BaseHidden)``

export const MobileNavigation = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Root = styled('div')`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || '0'};
  text-align: left;
`

export const ImageContainer = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: -20px 0 15px 0;

  ${props => props.theme.breakpoints.between('xs', 'md')} {
    display: none;
  }
`

export const ImageSuccess = styled('img')`
  width: 130px;
  margin-top: 45px;
  margin-bottom: 45px;
`

export const Instructions = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin: 0;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: left;
  }
`

export const Title = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;

  ${props => props.theme.breakpoints.down('sm')} {
    font-size: 22px;
    line-height: 26px;
    margin: 0;
    text-align: left;
  }
`
export const Conditions = styled('div')`
  align-items: center;
  background: rgba(0, 100, 255, 0.03);
  border-radius: 4px;
  border: 1px solid ${props => props.theme.palette.brand.primary};
  color: ${props => props.theme.palette.brand.black1};
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 20px;

  padding: 14px 14px;
  width: 95%;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: center;
  }
`

export const TermsLink = styled('a')``

export const TaxesKey = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  button.MuiButtonBase-root {
    background-color: ${props => props.theme.palette.custom.darkBlue};
  }

  ${props => props.theme.breakpoints.between('sm', 'lg')} {
    align-items: flex-start;
  }
`

export const ButtonClave = styled(Button)`
  &.MuiButtonBase-root {
    background-color: ${props => props.theme.palette.custom.darkBlue};
  }
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const RightSection = styled('div')`
  display: flex;
  flex-direction: column;
  min-width: 320px;
`

export const Image = styled('img')`
  margin-top: -80px;
  width: 100%;
`
